export default __webpack_public_path__ + "static/media/reflect.ba10f398.png";